<template>
  <div>
    <headline-container headline="Opportunities" :breadcrumbs="[{text: 'Opportunities'}]"/>

    <div v-if="portals !== null" class="container">
      <filter-form v-model="filters" :portals="portals"/>

      <hr>

      <div class="row">
        <div class="col-sm-24">
          <overview-panel :filters="filters" :selected-metrics="selectedMetrics" :metrics="metrics"/>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <list-panel :filters="filters"/>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-8">
          <legend-panel/>
        </div>

        <div class="col-sm-16">
          <by-user-panel :filters="filters" :selected-metrics="selectedMetrics" :metrics="metrics"/>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <by-week-panel :filters.sync="filters" :selected-metrics="selectedMetrics" :metrics="metrics"/>
        </div>
      </div>
    </div>

    <settings-modal v-model="selectedMetrics" :metrics="metrics" :filters.sync="filters"/>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import ByUserPanel from '@/components/Dashboards/Opportunities/ByUserPanel'
import ByWeekPanel from '@/components/Dashboards/Opportunities/ByWeekPanel'
import FilterForm from '@/components/Dashboards/Opportunities/FilterForm'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import LegendPanel from '@/components/Dashboards/Opportunities/LegendPanel'
import ListPanel from '@/components/Dashboards/Opportunities/ListPanel'
import OverviewPanel from '@/components/Dashboards/Opportunities/OverviewPanel'
import SettingsModal from '@/components/Dashboards/Opportunities/SettingsModal'

export default {
  components: {
    ByUserPanel,
    ByWeekPanel,
    FilterForm,
    HeadlineContainer,
    LegendPanel,
    ListPanel,
    OverviewPanel,
    SettingsModal
  },

  data() {
    return {
      filters: {
        conversion_expected_from: moment().startOf('isoweek').format('YYYY-MM-DD'),
        conversion_expected_to: moment().endOf('isoweek').format('YYYY-MM-DD'),
      },

      portals: null,

      selectedMetrics: JSON.parse(localStorage.getItem('opportunity_metrics') || '{"first":"total_value","second":"converted_value"}')
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    metrics() {
      return [
        {value: 'total_value', label: 'Total Value'},
        {value: 'open_value', label: 'Open Value'},
        {value: 'closed_value', label: 'Closed Value'},
        {value: 'missed_value', label: 'Missed Value'},
        {value: 'converted_value', label: 'Converted Value'},
        {value: 'actual_value', label: 'Actual Value'},
      ]
    }
  },

  watch: {
    selectedMetrics(value) {
      localStorage.setItem('opportunity_metrics', JSON.stringify(value))
    }
  },

  methods: {
    load() {
      http.get('/api/v2/portals').then(response => {
            this.portals = response.data.data
          })
    }
  }
}
</script>
